import styled from "styled-components"
import Img from "gatsby-image"

export const StyledPrivatelyImage = styled(Img)``
